module.exports = __webpack_public_path__ + "static/img/game7.41739aa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/doubleFestival/3/game7.png
// module id = nb6S
// module chunks = 1